export default "__VITE_ASSET__D39yZeKi__"